import { render } from "./WalletDetail.vue?vue&type=template&id=0beb2eb9&scoped=true"
import script from "./WalletDetail.vue?vue&type=script&lang=js"
export * from "./WalletDetail.vue?vue&type=script&lang=js"

import "./WalletDetail.vue?vue&type=style&index=0&id=0beb2eb9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0beb2eb9"]])

export default __exports__